import api from "api/config";

export const getArrivalsAPI = async (payload) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/arrivals/list",
    data: payload,
  });

  return response.data;
};

export const getArrivalDetailsAPI = async (reservationId, payload) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/arrivals/${reservationId}/details`,
    data: payload,
  });

  return response.data;
};

export const getArrivalsCalendarAPI = async (payload) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/arrivals/calendar",
    data: payload,
  });

  return response.data;
};

export const saveArrivalUpdatesAPI = async (reservationId, payload) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/arrivals/${reservationId}/save-updates`,
    data: payload,
  });

  return response.data;
};

export const toggleArrivalChecklistAPI = async (reservationId, payload) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/arrivals/${reservationId}/checklist/toggle`,
    data: payload,
  });

  return response.data;
};

export const generateReservationSummaryAPI = async (reservationId, idempotencyKey) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/reservations/${reservationId}/generate-summary`,
    headers: {
      "Idempotency-Key": idempotencyKey,
    },
  });

  return response.data;
};
